import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { atoms } from '@fiverr-private/theme';
import { Rating } from '@fiverr-private/orca';
import { getContext } from '@fiverr-private/fiverr_context';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { getSellerUrl } from '../../../../utils/getSellerUrl/getSellerUrl';
import RatingWrapper from '../../../shared/RatingWrapper';
import { SellerLevelBadge } from '../../../shared/SellerLevelBadge';

const SELLER_REVIEWS_ANCHOR = 'Reviews';
const AGENCY_REVIEWS_ANCHOR = 'reviews_tab';

interface RatingLineProps {
  rating: number;
  ratingsCount: number;
}

export const RatingLine: React.FC<RatingLineProps> = ({ rating, ratingsCount }) => {
  const themeOverride = useRatingTheme();
  const onRatingClick = useReviewsRedirect();
  return (
    <Stack gap="3" alignItems="center" width="fit-content">
      <RatingWrapper
        className={atoms({ fontSize: 'b_md', lineHeight: 'b_md' })}
        rating={rating}
        ratingsCount={ratingsCount}
        themeOverride={themeOverride}
        onClick={onRatingClick}
      />
      <SellerLevelBadge withSeparator />
    </Stack>
  );
};

const useReviewsRedirect = () => {
  const {
    pathfinderWrapper,
    seller: { isAgency, agency },
  } = useGigPageContext();

  return () => {
    if (isAgency && agency?.slug) {
      const agencyUrl = pathfinderWrapper.pathfinder('agency_page', { agency_slug: agency.slug });
      window.open(`${agencyUrl}#${AGENCY_REVIEWS_ANCHOR}`, '_blank', 'noopener,noreferrer');
    } else {
      const sellerUrl = getSellerUrl({ pathfinderWrapper });
      window.open(`${sellerUrl}#${SELLER_REVIEWS_ANCHOR}`, '_blank', 'noopener,noreferrer');
    }
  };
};

const useRatingTheme = () => {
  const { userId } = getContext();
  if (!userId) {
    return undefined;
  }
  // @ts-expect-error No TS definitions come from Orca.Rating component
  return Rating.THEMES.FIVE_STARS;
};
